import split from 'lodash/split';
import last from 'lodash/last';
import first from 'lodash/first';

export const resolve = path => first(split(last(split(path, '/')), '.'));

export const getUrl = slug => `/pages/${slug}.html`;

export default undefined;
